import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { secondDtpJobRetrieveRequest } from 'actions/jobs/employees';
import { isSecondDtpJobDetailLoading } from 'selectors/loading';
import EmployeeJobDetailHOC from './EmployeeJobDetailHOC';
import JobDetail from './presenter';


const mapStateToProps = (state, props) => {
  const { id } = props.params;
  return {
    id,
    roleKey: 'secondDtp',
    isLoading: isSecondDtpJobDetailLoading(state, id),
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    retrieveRequest: secondDtpJobRetrieveRequest,
  }, disptach)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeJobDetailHOC(JobDetail));